import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedFilters } from '../models/Items/ItemListRequest';
import { MULTI_SELECT_FIELD_NAMES, PRODUCT_TYPE_DROPDOWN_OPTIONS } from '../pages/Products/EditItem/Constants';

type StatusReportsFilterValues = Partial<SelectedFilters & {
    reportType: string;
}>;

type FiltersState = {
    selectedFilterOptions: any;
    selectedFilterValues: StatusReportsFilterValues;
};

interface StatusReportsState {
    statusReportsListView: FiltersState;
};

export const initialStatusReportsRequest = {
    [MULTI_SELECT_FIELD_NAMES.developmentType]: [PRODUCT_TYPE_DROPDOWN_OPTIONS[0].id],
    reportType: ''
};

const initialState: StatusReportsState = {
    statusReportsListView: {
        selectedFilterOptions: {},
        selectedFilterValues: {}
    }
};

const statusReports = createSlice({
    name: 'statusReports',
    initialState,
    reducers: {
        updateStatusReportsViewSelectedFilterOptions(state, action: PayloadAction<any>) {
            state.statusReportsListView.selectedFilterOptions = action.payload;
        },
        updateStatusReportsViewSelectedFilterValues(state, action: PayloadAction<StatusReportsFilterValues>) {
            state.statusReportsListView.selectedFilterValues = action.payload;
        },
    },
});

export const { updateStatusReportsViewSelectedFilterOptions, updateStatusReportsViewSelectedFilterValues } = statusReports.actions;

export default statusReports.reducer;